export default __webpack_public_path__ + "static/media/X_Old_Black.dff9339e.png";